<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-map-marker"
          inline
          class="px-5 py-4 ml-0"
          title="Áreas de Concessão"
          elevation="0"
        >
          <v-row class="mt-4" justify="space-between">
            <v-col cols="auto">
              <v-btn
                id="btn-gerenciar-municipios"
                color="accent"
                dark
                relative
                medium
                outlined
                @click="$router.push('/administracao/area-concessao/add')"
              >
                <v-icon left size="30px">
                  mdi-plus-circle
                </v-icon>
                Gerenciar municípios
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                id="btn-exportar-municipios"
                color="primary"
                dark
                relative
                medium
                outlined
                :loading="downloading"
                @click="exportarXlsx()"
              >
                <v-icon left size="30px">
                  mdi-file-excel-outline
                </v-icon>
                Exportar XLSX
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mb-1" justify="space-between">
            <v-col cols="12" sm="4" class="py-0 pr-sm-3">
              <v-text-field
                id="areasConcessao-search"
                v-model="search"
                append-icon="mdi-magnify"
                class="break-search bs-areasConcessao"
                label="Procurar"
                hide-details
                single-line
              />
            </v-col>
            <v-col cols="12" sm="4" class="py-0 pl-sm-3">
              <v-autocomplete
                v-model="selectedUf"
                :items="itemsFiltroUf"
                label="Filtrar UF"
                clearable
                hide-details
              />
            </v-col>
          </v-row>

          <v-data-table
            class="areasConcessao-table"
            :headers="headers"
            :items="filteredAreasConcessao"
            :search.sync="search"
            :page.sync="currentPage"
            :headerProps="{
              sortByText: 'Ordenar Por',
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página',
            }"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            :mobile-breakpoint="800"
            no-data-text="Nenhum município vinculado encontrado"
            no-results-text="Nenhum município correspondente encontrado"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id | addLeadingZero }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    id="desvincular-municipio"
                    min-width="0"
                    class="px-1"
                    fab
                    icon
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    @click="desvincularMunicipio(item)"
                  >
                    <v-icon>mdi-marker-cancel</v-icon>
                  </v-btn>
                </template>
                <span>Desvincular</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import tourMixins from "@/mixins/tourMixins";
  import AreaConcessaoService from "@/services/AreaConcessaoService";
  import MunicipiosService from "@/services/MunicipiosService";

  export default {
    name: "AreasConcessaoIndex",
    mixins: [tourMixins],
    components: {},
    data() {
      return {
        headers: [
          {
            text: "#",
            value: "id",
          },
          {
            text: "Código IBGE",
            value: "codigo_municipio",
          },
          {
            text: "UF",
            value: "nome_uf",
          },
          {
            text: "Município",
            value: "nome_municipio",
          },
          {
            sortable: false,
            text: "Ações",
            value: "actions",
            class: "pl-4",
          },
        ],
        areasConcessao: [],
        itemsFiltroUf: [],
        selectedUf: null,
        search: "",
        currentPage: 1,
        loading: false,
        downloading: false,
        arrTour: [
          {
            element: "#btn-gerenciar-municipios",
            intro:
              "Clicando neste botão você poderá gerenciar os municípios vinculados à distribuidora.",
            scrollTo: "tooltip",
            position: "right",
          },
          {
            element: "#areasConcessao-search",
            intro:
              "Neste campo você poderá pesquisar por Areas Concessao já cadastradas.",
            scrollTo: "tooltip",
            position: "bottom",
          },
        ],
      };
    },
    computed: {
      filteredAreasConcessao() {
        if (!this.selectedUf) {
          return this.areasConcessao;
        }

        return this.areasConcessao.filter(
          (item) => item.nome_uf === this.selectedUf,
        );
      },
    },
    watch: {
      selectedUf() {
        this.currentPage = 1;
      },
      search() {
        this.currentPage = 1;
      },
    },
    mounted() {
      this.getAreasConcessao();
    },
    methods: {
      async desvincularMunicipio(item) {
        try {
          this.loading = true;

          await AreaConcessaoService.desvincular(item.id);

          this.$toast.success("Município desvinculado com sucesso.", "", {
            position: "topRight",
          });

          await this.getAreasConcessao();
        } catch (err) {
          this.$toast.error("Erro ao desvincular município.", "", {
            position: "topRight",
          });
          console.error(err);
        } finally {
          this.loading = false;
        }
      },
      async getAreasConcessao() {
        this.loading = true;
        this.areasConcessao = [];
        this.currentPage = 1;

        try {
          const data = await AreaConcessaoService.getAll();
          this.areasConcessao = data.map((item) => ({
            id: item.id,
            codigo_municipio: item?.codigo_municipio,
            nome_municipio: item?.nome_municipio,
            nome_uf: item?.nome_uf,
          }));
          this.itemsFiltroUf = [
            ...new Set(
              this.areasConcessao.map((item) => item.nome_uf).filter(Boolean),
            ),
          ].sort();
        } catch (err) {
          this.$toast.error("Erro ao recuperar Areas Concessao.", "", {
            position: "topRight",
          });
          console.error(err);
        } finally {
          this.loading = false;
        }
      },
      async exportarXlsx() {
        try {
          this.downloading = true;

          const data = await MunicipiosService.downloadXlsx(
            "municipios_area_concessao",
            this.filteredAreasConcessao,
          );

          const blob = new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "municipios_area_concessao.xlsx";
          a.click();
        } catch (err) {
          console.error(err);
          this.$toast.error("Erro ao exportar municípios.", "", {
            position: "topRight",
          });
        } finally {
          this.downloading = false;
        }
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.importacoes.length
          ? this.arrTour
          : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      },
    },
  };
</script>

<style>
  .titulo {
    font-family: "styrene A";
    font-weight: 500;
    color: #3c4858 !important;
    font-size: 18px !important;
  }

  @media screen and (min-width: 800px) {
    .areasConcessao-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .areasConcessao-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-areasConcessao {
      width: 235.86px !important;
    }
  }
</style>
